//src/components/AdminTopBar.js
import { useAuth } from "../context/AuthContext";

export default function AdminTopBar() {
  const { authUser, logout } = useAuth();
  const letter =
    authUser?.user?.name?.charAt(0)?.toUpperCase() || "A";

  return (
    <div className="bg-black/30 backdrop-blur-xl px-4 py-3 border-b border-white/10 flex justify-between items-center">
      <div className="font-semibold text-white">Admin Panel</div>

      <div className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-full bg-purple-600 flex items-center justify-center font-bold">
          {letter}
        </div>

        <button
          onClick={logout}
          className="text-sm px-3 py-1 rounded bg-red-500/20 hover:bg-red-500/40 text-red-300"
        >
          Logout
        </button>
      </div>
    </div>
  );
}
